import { Outlet } from 'react-router-dom'

import { BookCartProvider } from '@/context/BookCartContext'

export function PublicBookLayout() {
  return (
    <BookCartProvider>
      <Outlet />
    </BookCartProvider>
  )
}
